import { html, render, type TemplateResult } from 'lit-html';
import styles from './pk-card.css?inline';

/**
 * `<pk-card>` — the centered "lightbox" surface used by auth-style pages and
 * any panel that wants the same treatment. See `docs/components/pk-card.md`.
 *
 * Slots:
 *   - `eyebrow` (or any child with `class="eyebrow"`) — small caps label
 *   - default                                         — body content (h1, lede, form, …)
 *   - `foot`                                          — small links beneath the body
 *
 * Attributes:
 *   - `wide`                                          — widens max-width from 520px to 760px
 *   - `no-accent-border`                              — removes the brand-coloured top border
 */
export class PkCard extends HTMLElement {
    static readonly tagName = 'pk-card';

    static get observedAttributes(): string[] {
        return ['wide', 'no-accent-border'];
    }

    private readonly _root: ShadowRoot;

    constructor() {
        super();
        this._root = this.attachShadow({ mode: 'open' });
    }

    connectedCallback(): void {
        this.render();
    }

    attributeChangedCallback(): void {
        this.render();
    }

    private template(): TemplateResult {
        return html`
            <style>${styles}</style>
            <slot name="eyebrow"></slot>
            <div class="body">
                <slot></slot>
            </div>
            <div class="foot">
                <slot name="foot"></slot>
            </div>
        `;
    }

    private render(): void {
        render(this.template(), this._root);
    }
}

if (!customElements.get(PkCard.tagName)) {
    customElements.define(PkCard.tagName, PkCard);
}

declare global {
    interface HTMLElementTagNameMap {
        'pk-card': PkCard;
    }
}
